import oAuthClient from './core';
import { useAuth } from './useAuth';
import useAuthStatusMutation from './useAuthStatusMutation';

const createAuthUrl = oAuthClient.createAuthUrl.bind(oAuthClient);

export { useAuthStatusMutation, createAuthUrl };
export default useAuth;
